import React from 'react';
import MathWorkshop2025 from '../views/MathWorkshop2025/MathWorkshop2025';

const ExtraCurricularActivitiesPage = () => {
  return <MathWorkshop2025 />;
};

export default ExtraCurricularActivitiesPage;